module.exports = __webpack_public_path__ + "img/Member icon-08.977a197f.png";